import React from 'react';
import SimpleModal from '../../../components/Modals/SimpleModal';
import {Grid, Icon, Typography, alpha
} from '@mui/material'
import {makeStyles} from '@mui/styles'
import Iconify from '../../../components/iconify';

/* This is a functional component in JavaScript React that renders a modal with an error message if the 
uuid program is wrong. It receives props such as `open`, `onClose`, and `onResetForm` and uses them to 
control the behavior of the modal. It also uses Material-UI components such as `Grid`, `Icon`, and 
`Typography`, and acustom `Iconify` component to display an icon. The `useStyles` hook is used to define 
custom styles for the component. */

/**
 * @module Layouts/Registration/modals/UUIDErrorModal
 * @description This is a functional component in JavaScript React that renders a modal with an error message if the 
uuid program is wrong. It receives props such as `open`, `onClose`, and `onResetForm` and uses them to 
control the behavior of the modal. It also uses Material-UI components such as `Grid`, `Icon`, and 
`Typography`, and acustom `Iconify` component to display an icon. The `useStyles` hook is used to define 
custom styles for the component.
 */

/**
 * 
 * @typedef UUIDErrorModal
 * @property {MUIStyles} classes - The styles for the component 
 * @property {Boolean} open - Variables that handles if this component is shown or not
 * @property {Function} onClose - This function closes this Component Modal
 
*/
const UUIDErrorModal = (props) => {

    const classes = useStyles()
    const {open, onClose, onResetForm} = props

    const onInnerClose = () => {
        //onResetForm()
        onClose()
    }

    return ( 
        <SimpleModal open={open} onClose={onInnerClose} disabledCloseBtn>
            <div className={classes.root}>
                <Grid container justifyContent='center' spacing={3}>
                    <Grid item>
                        <div className={classes.icon_container}>
                        <Iconify icon="ic:baseline-report-problem" width={16} sx={{
                            position:'absolute',
                            top:'50%', left:'50%',
                            transform:'translate(-50%, -50%)',
                            color:'#361e7d',
                            width:48,
                            height:48
                        }}/>
                            {/*<Icon className={classes.icon}>report_problem</Icon>*/}
                        </div>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography align='center'>
                            We couldn't detect a valid <strong>Program ID</strong> to start the Customer Registration Process. 
                        </Typography>
                        <Typography align='center' style={{marginTop:16}}>
                            Please try with another link 
                        </Typography>
                    </Grid>
                </Grid>
            </div>
        </SimpleModal>
     );
}

const useStyles = makeStyles(theme => ({
    root:{
        paddingTop:30
    },
    icon_container:{
        width:80,
        height:80,
        borderRadius:'50%',
        border:`1px solid ${alpha('#361e7d',0.2)}`,
        background:alpha('#361e7d',0.2),
        position:'relative'
    },
    icon:{
        position:'absolute',
        top:'50%', left:'50%',
        transform:'translate(-50%, -50%)',
        color:'#361e7d',
        fontSize:48
    }
}))
 
export default UUIDErrorModal;